import React from "react";
import { createRoot } from "react-dom/client";

import { initSentry } from "src/sentry";
import App from "src/App";

// Initialize error monitoring before anything else so early failures are caught.
initSentry();

function mount() {
  const rootElement = document.getElementById("app-root");
  if (!rootElement) return;

  let bootstrapData = {};
  try {
    bootstrapData = JSON.parse(rootElement.dataset.bootstrap || "{}");
  } catch {
    bootstrapData = {};
  }

  createRoot(rootElement).render(
    <React.StrictMode>
      <App bootstrapData={bootstrapData} />
    </React.StrictMode>
  );
}

document.addEventListener("DOMContentLoaded", mount);
